export const sortLocations = (a, b) => {
  if (a.locationType === 'Primary_Location') {
    return -1; // a should come before b
  } else if (b.locationType === 'Primary_Location') {
    return 1; // b should come before a
  } else {
    return a.locationType.localeCompare(b.locationType);
  }
};
